import React, { createContext, useContext, useState, useEffect } from "react";
import io from "socket.io-client";

const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_URL;
const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [userId, setUserId] = useState(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    return user ? user.id : null;
  });

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("currentUser"));
      console.log("Initializing socket connection for userId:", userId);
      const storedSocketId = localStorage.getItem("socketId");

      const newSocket = io(SOCKET_SERVER_URL, {
        path: "/socket.io",
        transports: ["websocket"],
        withCredentials: true,
        autoConnect: false,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 100,
        query: {
          ...(storedSocketId ? { socketId: storedSocketId } : {}),
          userId,
        },
      });

      // Handle socket connection
      newSocket.on("connect", () => {
        setSocket(newSocket);
      });

      // Handle socket disconnection
      newSocket.on("disconnect", () => {
        setSocket(null);
      });

      // Handle connection errors
      newSocket.on("connect_error", (error) => {
        console.error("Socket connection error:", error);
      });

      // Attempt to connect
      if (!newSocket.connected) {
        newSocket.connect();
      }
      return () => {
        try {
          newSocket.disconnect();
          localStorage.removeItem("socketId");
        } catch (disconnectError) {
          console.error("Error during socket disconnection:", disconnectError);
        }
      };
    } catch (error) {
      console.error("Error initializing socket:", error);
    }
  }, [userId]);

  return (
    <SocketContext.Provider value={{ setUserId, socket }}>
      {children}
    </SocketContext.Provider>
  );
};

// Custom hook to access the socket
export const useSocket = () => {
  return useContext(SocketContext);
};
